import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    coverPaddingBottom: {
      type: String,
      required: true,
      description: 'Percentage that controls the height of the cover. E.g.: "62" ',
    },
    bigBlock: {
      type: Boolean,
      default: false,
      description: 'Change styles of the Block. True if 3 blocks will be displayed in a row',
    },
  },
})
export default class ProductBlockSkeletonComponent extends Vue {}
